/** Map Amplify / Cognito thrown values to a user-facing English message string. */
export function mapAmplifyError(error: unknown): string {
  if (error && typeof error === "object" && "message" in error) {
    const message = String((error as { message: unknown }).message);
    if (message) return message;
  }
  if (error instanceof Error && error.message) return error.message;
  return "Authentication failed";
}
